// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common Button Styles */
.button {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  font-weight: 500;
}

.button:hover {
  background-color: #fff;
}

@media (min-width: 768px) {
  .button {
    font-size: 12px;
    font-weight: 400;
  }
}

.button.active {
  background-color: #05e27e;
  color: #111827;
}

.button.inactive {
  background-color: #fff;
  border: 1px solid #e5e7eb;
}

.button:focus {
  outline: none;
  transform: scale(1.05);
}

/* Dropdown Styles */
.custom-dropdown {
  /* width:120px; */
  text-align: inherit;
  justify-content: center;
  padding: 6px 13px 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
  color: #4b5563;
  outline: none;
  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}

.custom-dropdown:focus-visible {
  outline: none;
}

/* Order */
.secondary_button {
  padding: 12px 17px;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  font-weight: 400;
  background-color: #05e27e;
}
.secondary_button.active {
  background-color: #05e27e;
  color: #111827;
  padding: 12px 17px;
  border: 1px solid #05e27e;
}
.secondary_button.inactive {
  background-color: #fff;
  border: 1px solid #e5e7eb;
  padding: 12px 17px;
}

.btn-delete {
  padding: 12px 17px;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  font-weight: 500;
  background-color: #fff; /* default inactive */
  border: 1px solid #fca5a5; /* red-300 */
  color: #ef4444; /* red-500 */
}
/* .secondary_button:hover {
  background-color: #fff;
}





.secondary_button:focus {
  outline: none;
  transform: scale(1.05);
} */

.order-dropdown {
  /* width:120px; */
  text-align: inherit;
  justify-content: center;
  padding: 12px 15px 12px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
  color: #4b5563;
  outline: none;
  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}

.required-dropdown {
  /* width:120px; */
  text-align: inherit;
  justify-content: center;
  padding: 12px 15px 12px 10px;
  border-radius: 6px;
  background-color: white;
  color: #4b5563;
  outline: none;
  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}
.main-dropdown {
  /* width:120px; */
  text-align: inherit;
  justify-content: center;
  padding: 12px 15px 12px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
  color: #4b5563;
  outline: none;
  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}
/*Input */
.primary_input {
  color: #111827;
  padding: 12px 14px;
  border-radius: 6px;
  border: 1px solid var(--gray-300, #d1d5db);
  background: var(--white, #fff);
  width: 100%;
  font-weight: 400;
  font-size: 14px;
}

.primary_input:focus {
  outline: none;
}

.required_input {
  color: #111827;
  padding: 12px 14px;
  border-radius: 6px;
  background: var(--white, #fff);
  width: 100%;
  font-weight: 400;
  font-size: 14px;
}

.required_input:focus {
  outline: none;
}
.primary_label {
  /* block; text-gray-700 font-medium mb-1 */

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #374151;
  display: block;
  margin-bottom: 4px;
}
.secondary_input {
  color: #111827;
  padding: 12px 14px;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
}

/* Custom styles for the Quill editor container */
.editor-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 1px;
}

/* Custom styles for the Quill editor */
.editor {
  border: 1px solid #ddd;
  background-color: white;
  min-height: 200px;
  font-size: 16px;
  font-family: "Inter", sans-serif;
}


/* Input */
.base_input {
  color: #111827;
  padding: 14px 13px;
  border-radius: 6px;
  border: 1px solid var(--gray-300, #d1d5db);
  background: var(--white, #fff);
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/style/components.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gEAAgE;EAChE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,sBAAsB,EAAE,qBAAqB;EAC7C,yBAAyB,EAAE,YAAY;EACvC,cAAc,EAAE,YAAY;AAC9B;AACA;;;;;;;;;;;GAWG;;AAEH;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gEAAgE;EAChE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gEAAgE;EAChE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gEAAgE;EAChE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA,SAAS;AACT;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,0CAA0C;;EAE1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;;AAGA,UAAU;AACV;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf","sourcesContent":["/* Common Button Styles */\n.button {\n  padding: 8px 16px;\n  font-size: 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.2s;\n  font-weight: 500;\n}\n\n.button:hover {\n  background-color: #fff;\n}\n\n@media (min-width: 768px) {\n  .button {\n    font-size: 12px;\n    font-weight: 400;\n  }\n}\n\n.button.active {\n  background-color: #05e27e;\n  color: #111827;\n}\n\n.button.inactive {\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n}\n\n.button:focus {\n  outline: none;\n  transform: scale(1.05);\n}\n\n/* Dropdown Styles */\n.custom-dropdown {\n  /* width:120px; */\n  text-align: inherit;\n  justify-content: center;\n  padding: 6px 13px 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background-color: white;\n  color: #4b5563;\n  outline: none;\n  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  cursor: pointer;\n}\n\n.custom-dropdown:focus-visible {\n  outline: none;\n}\n\n/* Order */\n.secondary_button {\n  padding: 12px 17px;\n  font-size: 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.2s;\n  font-weight: 400;\n  background-color: #05e27e;\n}\n.secondary_button.active {\n  background-color: #05e27e;\n  color: #111827;\n  padding: 12px 17px;\n  border: 1px solid #05e27e;\n}\n.secondary_button.inactive {\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  padding: 12px 17px;\n}\n\n.btn-delete {\n  padding: 12px 17px;\n  font-size: 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.2s;\n  font-weight: 500;\n  background-color: #fff; /* default inactive */\n  border: 1px solid #fca5a5; /* red-300 */\n  color: #ef4444; /* red-500 */\n}\n/* .secondary_button:hover {\n  background-color: #fff;\n}\n\n\n\n\n\n.secondary_button:focus {\n  outline: none;\n  transform: scale(1.05);\n} */\n\n.order-dropdown {\n  /* width:120px; */\n  text-align: inherit;\n  justify-content: center;\n  padding: 12px 15px 12px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background-color: white;\n  color: #4b5563;\n  outline: none;\n  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  cursor: pointer;\n}\n\n.required-dropdown {\n  /* width:120px; */\n  text-align: inherit;\n  justify-content: center;\n  padding: 12px 15px 12px 10px;\n  border-radius: 6px;\n  background-color: white;\n  color: #4b5563;\n  outline: none;\n  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  cursor: pointer;\n}\n.main-dropdown {\n  /* width:120px; */\n  text-align: inherit;\n  justify-content: center;\n  padding: 12px 15px 12px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background-color: white;\n  color: #4b5563;\n  outline: none;\n  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  cursor: pointer;\n}\n/*Input */\n.primary_input {\n  color: #111827;\n  padding: 12px 14px;\n  border-radius: 6px;\n  border: 1px solid var(--gray-300, #d1d5db);\n  background: var(--white, #fff);\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.primary_input:focus {\n  outline: none;\n}\n\n.required_input {\n  color: #111827;\n  padding: 12px 14px;\n  border-radius: 6px;\n  background: var(--white, #fff);\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.required_input:focus {\n  outline: none;\n}\n.primary_label {\n  /* block; text-gray-700 font-medium mb-1 */\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  color: #374151;\n  display: block;\n  margin-bottom: 4px;\n}\n.secondary_input {\n  color: #111827;\n  padding: 12px 14px;\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n/* Custom styles for the Quill editor container */\n.editor-container {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 1px;\n}\n\n/* Custom styles for the Quill editor */\n.editor {\n  border: 1px solid #ddd;\n  background-color: white;\n  min-height: 200px;\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n\n\n/* Input */\n.base_input {\n  color: #111827;\n  padding: 14px 13px;\n  border-radius: 6px;\n  border: 1px solid var(--gray-300, #d1d5db);\n  background: var(--white, #fff);\n  width: 100%;\n  font-weight: 400;\n  font-size: 16px;\n  outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
